export default __webpack_public_path__ + "static/bg2-561b23be47f5f633635fde6224bfa6dc.jpg";